import { Component, AfterViewInit, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AuthService } from '../../core/service/authentication/auth.service';
import { LoaderService } from '../../core/service/loader/loader.service';
import { Router } from '@angular/router';
import { ApiResponseStatus } from '../../core/models/common/enums/api-response-status.enum';
import ErrorResponse from '../../core/models/common/error-response.model';
import { NotificationService } from '../../core/service/notifications/notification.service';
import { TicketService } from '../../core/service/tickets/tickets.service';
import Ticket from '../../core/models/ticket.model';
import { ApiResponseErrorCodes } from '../../core/models/common/enums/api-response-error-codes.enum';
import User from '../../core/models/user.model';
import { SeedService } from '../../core/service/seed.service';

@Component({
  selector: 'app-seed',
  templateUrl: './seed.component.html',
  styleUrls: ['./seed.component.scss'],
})
export class SeedComponent implements OnInit, AfterViewInit {
  login: FormGroup = new FormGroup({
    email: new FormControl('', {
      validators: [Validators.required, Validators.email],
    }),
    password: new FormControl('', {
      validators: [Validators.required, Validators.minLength(8)],
    }),
  });

  isLoggedIn = false;
  isLoginInError = false;
  areUserSeeded = false;
  usersSeedError: string = '';
  areTicketsSeeded = false;
  ticketsSeedError: string = '';
  userCount = 1;
  ticketCount = 1;
  authToken: string = '';

  constructor(
    private loaderService: LoaderService,
    private seedService: SeedService,
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.loaderService.showLoader();
    this.loaderService.hideLoader();
  }

  onLogin(): void {
    if (this.login.invalid) return;

    const { email, password } = this.login.value;

    this.seedService.loginAsAdmin(email, password).subscribe({
      next: (response) => {
        this.isLoggedIn = true;
        this.authToken = response.content.authorization.token;
      },
      error: () => {
        this.isLoginInError = true;
      }
    });
  }

  onSeedUsers(): void {
    this.seedService.seedUsers(this.userCount, this.authToken).subscribe({
      next: () => this.areUserSeeded = true,
      error: (error) => {
        this.areUserSeeded = false;

        this.usersSeedError = error?.message || 'errore sconosciuto';
      }
    });
  }

  onSeedTickets(): void {
    this.seedService.seedTickets(this.ticketCount, this.authToken).subscribe({
      next: () => this.areTicketsSeeded = true,
      error: (error) => {
        this.areTicketsSeeded = false;

        this.ticketsSeedError = error?.message || 'errore sconosciuto';
      }
    });
  }
}
